export default "__VITE_ASSET__DsS3IHc$__"